import { useMutation } from 'react-query';
import { registerNewVendor } from '../../../store/apiCalls/authentication';

function OnRegisterVendor(sucessHandler,error,setError) {
    return {
        ...useMutation(registerNewVendor, {
            onSuccess: (data) => { sucessHandler(data)
            setError({...error,apiError:''})
            },
            onError: (errMsg) => {
                setError({...error,apiError:errMsg.response.data.message||"Something went wrong, Please try again after sometime"})
            },
        })
    }
}


export {
    OnRegisterVendor,
}
